// extracted by mini-css-extract-plugin
export default {"button":"red-micro__button___ZZFR7 red__button___G2JYw base__button___zT0JW primary__button___frFdc base__button___zT0JW"};